import  { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { BiArea, BiBath, BiBuildingHouse } from 'react-icons/bi';
import { BsDownload, BsShareFill } from 'react-icons/bs';
import { IoChevronDownOutline, IoPricetagOutline } from 'react-icons/io5';
import {
  MdLocationOn,
  MdOutlineBedroomChild,
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight
} from 'react-icons/md';
import { RiCommunityLine } from 'react-icons/ri';
import { TbParking } from 'react-icons/tb';
import ClientManagerCard from '../../Component/ClientManagerCard';
import HeadingWithUnderline from '../../Component/HeadingWithUnderline';
import ListItemWithCheckMark from '../../Component/ListItemWithCheckMark';
import MortgageCalculator from '../../Component/MortgageCalculator';
import Tabs from '../../Component/Tabs';
import classes from './ProjectDetail.module.css';
import BannerImageAd from '../../Component/BannerImageAd';
import Button from '../../Component/Button/Button';
import ElasticCarousel from '../../Component/ElasticCarousel';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import DetailPageHeroSection from '../../Component/DetailPageHeroSection';
import ShareModal from '../../Component/ShareModal/ShareModal';
import Tooltip from '../../Component/Tooltip';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import { toast } from 'react-toastify';
import BankLoanBanner from '../../Component/BankLoanBanner';
import CustomOverlay from '../../Component/CustomOverlay';
import Footer from '../../Component/Footer';
import Header from '../../Component/Header';
import IconList from '../../Component/IconList/IconList';
import { Loader } from '../../Component/Loader';
import RenderBreadcrum from '../../Component/RenderBreadcrum';
import { isMobileViewHook } from '../../CustomHooks/isMobileViewHook';
import { downloadFileFromURL } from '../../Helper/downloadFile';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { imageUrl, pdfUrl } from '../../config/apiUrl';
import {
  AreaIcon,
  Circle360Icon,
  MapMarkerIcon,
  PhotoIcon,
  StreetViewIcon,
  VideoIcon,
  NoOfUnits
} from '../../constant/imagePath';
import {
  useFavoriteEntityMutation,
  useGetPublicProjectsDetailQuery
} from '../../store/apiSlice/apiSlice';
import { m2ToFt2, usdToOther } from '../../utils/helpers';

const ProjectDetail = () => {
  const { allBanners } = useSelector((state) => state.commonReducer);
  // eslint-disable-next-line no-unused-vars
  const [is1200, Set1200] = useState(false);
  const navigate = useNavigate();
  const { user, isLogin } = useSelector((state) => state?.authReducer);
  const { areaUnit, currency } = useSelector((state) => state?.converterReducer);

  const [searchParams] = useSearchParams();
  const adminToken = searchParams.get('token') || '';

  const { t } = useTranslation('projectDetail');
  const { t: t2 } = useTranslation('webCommon');

  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const slug = useParams()?.slug;
  const { data, isLoading, refetch } = useGetPublicProjectsDetailQuery({
    slug: `${slug}?token=${adminToken || ''}`
  });
  const projectData = data?.data;
  const __projectType = data?.data?.type?.toLowerCase() === 'project' ? 'project' : undefined;

  const thisPageBanners = allBanners?.filter((b) => b.page === `${__projectType}-detail`);

  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(projectData?.projectUnit[0]);

  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();

  const isFavorite = projectData?.favoriteBy?.includes(user?._id);

  const tabsData = [
    {
      icon: <ReactSVG src={PhotoIcon} size={20} />,
      id: '1',
      value: 'Photos',
      tooltipText: t('tabs.photos')
    },
    {
      icon: <ReactSVG src={AreaIcon} size={20} />,
      id: '2',
      value: 'Plans',
      tooltipText: t('tabs.plans')
    },
    {
      icon: <ReactSVG src={Circle360Icon} size={20} />,
      id: '3',
      value: '360',
      disabled: !projectData?.threeSixtyViewLink,
      tooltipText: t('tabs.360view')
    },
    {
      icon: <ReactSVG src={MapMarkerIcon} size={20} />,
      id: '4',
      value: 'Location',
      tooltipText: t('tabs.location')
    },
    {
      icon: <ReactSVG src={StreetViewIcon} size={20} />,
      id: '5',
      value: 'Street',
      tooltipText: t('tabs.streetView')
    },
    {
      icon: <ReactSVG src={VideoIcon} size={20} />,
      id: '6',
      value: 'Video',
      disabled: !projectData?.videoLink,
      tooltipText: t('tabs.video')
    }
  ];
  const [tabValue, setTabValue] = useState(tabsData[0]);

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: projectData?._id, type: 'project' });
    if (res?.data) {
      if (res?.data?.data?.favoriteBy?.includes(user?._id)) {
        toast.success(t('toast.added'));
      } else {
        toast.success(t('toast.removed'));
      }
      refetch();
    }
  };

  //

  const handleNext = () => {
    if (!selectedUnit) return;
    const currentIndex = projectData?.projectUnit.findIndex(
      (item) => item._id === selectedUnit._id
    );
    if (currentIndex >= 0 && currentIndex < projectData?.projectUnit.length - 1) {
      setSelectedUnit(projectData?.projectUnit[currentIndex + 1]);
    }
  };

  const handlePrev = () => {
    if (!selectedUnit) return;
    const currentIndex = projectData?.projectUnit.findIndex(
      (item) => item._id === selectedUnit._id
    );
    if (currentIndex > 0) {
      setSelectedUnit(projectData?.projectUnit[currentIndex - 1]);
    }
  };

  //
  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  useEffect(() => {
    isMobileViewHook(Set1200, 1200);
    if (projectData?.projectUnit) {
      setSelectedUnit(projectData?.projectUnit[0]);
    }
  }, [isLoading]);

 

  return (
    <>
      <style>
        {`
      
      .${classes.unitfloorImages} .rec-swipable{
        height:330px !important;
    }
    .${classes.popoverMain} .popover-arrow {
      left: unset !important;
      right: 50% !important;
      transform: translate(-50%, 0px) !important;
  }

    @media (max-width:600px){
      .${classes.unitfloorImages} .rec-swipable{
        height:250px !important;
    }
    }

    
      `}
      </style>
      <Header containerClass={''} />

      {isLoading ? (
        <Loader />
      ) : (
        <div className={`${classes.main}`}>
          <section className={classes.images}>
            <DetailPageHeroSection
              // plansPicture={plansPicture} images={images} text={tabValue?.value}
              // showLandMarks={false}
              plansPicture={projectData?.planImages ?? []}
              images={projectData?.images ?? []}
              text={tabValue?.value}
              videoLink={projectData?.videoLink ?? ''}
              location={{
                lat: projectData?.location?.coordinates?.[1],
                lng: projectData?.location?.coordinates?.[0]
              }}
              threeSixtyImage={projectData?.threeSixtyViewLink}
            />

     

            <div className={classes.socialIconsWrap1}>
              <div className={[classes.socialIcons1].join(' ')}>
                <BsShareFill
                  onClick={() => setIsShareModalOpen(true)}
                  fill="var(--primary-clr)"
                  size={25}
                />
              </div>
              <div className={[classes.socialIcons1].join(' ')}>
                {isFavorite ? (
                  <AiFillHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="var(--primary-clr)"
                    size={25}
                  />
                ) : (
                  <AiOutlineHeart
                    onClick={() => {
                      if (!handleAction()) return;
                      handleFavorite();
                    }}
                    fill="#9d9e9e"
                    size={25}
                  />
                )}
              </div>
              {/* <div className={[classes.socialIcons1].join(' ')}>
                  <IoMdPrint fill="var(--primary-clr)" size={25} />
                </div> */}
            </div>
          </section>
          <Container className={[classes.container].join(' ')}>
            <Row className={classes.gap}>
              <Col md={12}>
                <div className={classes.BreadCrumsDiv}>
                  <RenderBreadcrum data={projectData} type="project" />
                </div>
              </Col>
              <Col md={12} lg={8} className={classes.col1}>
                <div className={classes.TopSections}>
                  <div className={classes.priceRow}>
                    {projectData?.logo && (
                      <div className={classes.mainImage}>
                        <img src={imageUrl(projectData?.logo)} alt="" />
                      </div>
                    )}
                    <div className={classes.contentMain}>
                      <div className={classes.title}>
                        <p>{projectData?.name?.[selectedLanguage]}</p>
                        <div className={classes.mainTabsDiv}>
                          <Tabs
                            className={classes.tab}
                            value={tabValue}
                            // setValue={(e) => {
                            //   setTabValue(e);
                            // }}
                            tabClass={classes.tab}
                            setValue={(e) => {
                              setTabValue(e);
                            }}
                            tabsData={tabsData}
                          />
                        </div>

                        {/* tabs here */}
                        {/* <Tooltip text={'Download Brouchure'}>
                        <ImFolderDownload size={30} fill="var(--primary-clr)" />
                      </Tooltip> */}
                      </div>
                      <div className={classes.price}>
                        <p>
                          {t2('words.from')}{' '}
                          {usdToOther({ amount: projectData?.price, ...currency })}
                        </p>
                      </div>
                      <div className={classes.desc}>
                        <p>{projectData?.title?.[selectedLanguage]}</p>
                      </div>

                      <div className={classes.addressWrap}>
                        <MdLocationOn size={20} color="var(--primary-clr)" />
                        <p>{projectData?.address}</p>
                      </div>
                    </div>
                  </div>
                  <div className={classes.propertyDetailWrap}>
                    <div className={classes.propertyDetailWrapInner}>
                      <IconList
                        className={classes.infoIcons}
                        Icon={BiBuildingHouse}
                        label={t('tooltips.projectType')}
                        value={projectData?.projectType?.title?.[selectedLanguage]}
                      />
                      <div  className={classes.propertyDetail}>
                        <Tooltip text={t('tooltips.noOfUnits')}>
                          <ReactSVG fill="#484848" className={classes.svgIcon} src={NoOfUnits} />
                        </Tooltip>

                        <div className={classes.infoIcons}>
                          <span>
                            {projectData?.noOfUnits} {t('units')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {projectData?.projectBrochure && (
                      <Button
                        className={classes.btn}
                        leftIcon={<BsDownload />}
                        onClick={() => {
                          downloadFileFromURL(
                            pdfUrl(projectData?.projectBrochure),
                            projectData?.projectBrochureName
                          );
                        }}>
                        {t('downloadBrochure')}
                      </Button>
                    )}
                    {/* <div className={[classes.propertyDetail, classes.infoIcons].join(' ')}>
                      <Tooltip text={t('tooltips.deliveryDate')}>
                        <ReactSVG
                          color="var(--text-dark-gray-clr)"
                          className={classes.svgIcon}
                          src={DateTime}
                        />
                      </Tooltip>
                      <p>{moment(projectData?.deliveryDate).format('ll')}</p>
                    </div> */}

                    {/* </div> */}

                    {/* <div className={classes.propertyDetail}>
                    <Tooltip text="Property Type">
                      <RiHotelFill color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.type}</p>
                  </div>
                  <div className={classes.propertyDetail}>
                    <Tooltip text="Area (sq ft)">
                      <BsGrid3X3Gap color="var(--text-dark-gray-clr)" />
                    </Tooltip>

                    <p>{data?.area}</p>
                  </div>
                  <div className={classes.propertyDetail}>
                    <Tooltip text="Rooms">
                      <MdOutlineHotel color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.noOfBedRooms}</p>
                  </div>
                  <div className={classes.propertyDetail}>
                    <Tooltip text="Bathrooms">
                      <MdOutlineBathtub color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.noOfBathRooms}</p>
                  </div>
                  <div className={classes.propertyDetail}>
                    <Tooltip text="Level">
                      <FaLevelUpAlt color="var(--text-dark-gray-clr)" />
                    </Tooltip>

                    <p>{data?.level}</p>
                  </div> */}
                    {/* </div> */}
                  </div>
                </div>
                <div className={classes.detailWrap}>
                  <Col lg={12}>
                    <div className={classes.overView}>
                      <HeadingWithUnderline underlineColor="transparent">
                        <h5>{t('overview.title')}</h5>
                      </HeadingWithUnderline>
                      <Row className={classes.overViewRow}>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.listingID')}</span>
                              <span>{projectData?.listingId}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.type')}</span>
                              <span>{projectData?.projectType?.title?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.price')}</span>
                              <span>{usdToOther({ amount: projectData?.price, ...currency })}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.developer')}</span>
                              <span>{projectData?.developerName?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.area')}</span>
                              <span>
                                {areaUnit == 'm²'
                                  ? projectData?.minimumArea + ' m²'
                                  : m2ToFt2({
                                      area: projectData?.minimumArea,
                                      areaUnit: 'ft²',
                                      unit: true
                                    })}{' '}
                                -{' '}
                                {areaUnit == 'm²'
                                  ? projectData?.maximumArea + ' m²'
                                  : m2ToFt2({
                                      area: projectData?.maximumArea,
                                      areaUnit: 'ft²',
                                      unit: true
                                    })}{' '}
                              </span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.noOfUnits')}</span>
                              <span>{projectData?.noOfUnits}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                        <Col lg={6}>
                          {/* Start Year is Nothing Here */}

                          {/* <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                        <div className={`flex-sb ${classes.listItem}`}>
                          <span>Start Year</span>
                          <span>{moment().format('YYYY')}</span>
                        </div>
                      </ListItemWithCheckMark> */}

                          {/* Start Year is Nothing Here */}

                          {/* <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                        <div className={`flex-sb ${classes.listItem}`}>
                          <span>Currency</span>
                          <span>{'dollar'}</span>
                        </div>
                      </ListItemWithCheckMark>
                      <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                        <div className={`flex-sb ${classes.listItem}`}>
                          <span>Unit</span>
                          <span>{'m2'}</span>
                        </div>
                      </ListItemWithCheckMark> */}
                          {/* <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                          <div className={`flex-sb ${classes.listItem}`}>
                            <span>{t('overview.plannedDeliveryDate')}</span>
                            <span>
                              {' '}
                              {moment(projectData?.deliveryDate).format('DD MMM YYYY hh:mm')}
                            </span>
                          </div>
                        </ListItemWithCheckMark> */}
                          <ListItemWithCheckMark mainClass={classes.list} showCheck={false}>
                            <div className={`flex-sb ${classes.listItem}`}>
                              <span>{t('overview.projectStatus')}</span>
                              <span>{projectData?.status?.title?.[selectedLanguage]}</span>
                            </div>
                          </ListItemWithCheckMark>
                        </Col>
                      </Row>
                    </div>
                  </Col>

                  <div className={classes.description}>
                    <HeadingWithUnderline underlineColor="transparent">
                      <h5>{t('description')}</h5>
                    </HeadingWithUnderline>
                    {projectData?.description?.[selectedLanguage] && (
                      <p
                        dangerouslySetInnerHTML={{
                          __html: projectData?.description?.[selectedLanguage]
                        }}
                      />
                    )}
                  </div>
                  <Col md={8}>
                    <div className={classes.interior}>
                      <HeadingWithUnderline underlineColor="transparent">
                        <h5>{t('amenities')}</h5>
                      </HeadingWithUnderline>
                      <div className={classes.interior}>
                        <HeadingWithUnderline underlineColor="transparent">
                          <h6>{t('interiorAmenities')}</h6>
                        </HeadingWithUnderline>
                        <Row className={classes.interiors}>
                          {projectData?.interiorAmenities?.map((item, index) => (
                            <div key={`${item?._id}-${index}`} className={classes.innersDiv}>
                              <ListItemWithCheckMark mainClass="flex-align-center">
                                <div className={`flex-sb ${classes.floor_unit_item}`}>
                                  <span>{item?.title?.[selectedLanguage]}</span>
                                </div>
                              </ListItemWithCheckMark>
                            </div>
                          ))}
                        </Row>
                      </div>
                      <div className={classes.interior}>
                        <HeadingWithUnderline underlineColor="transparent">
                          <h6>{t('exteriorAmenities')}</h6>
                        </HeadingWithUnderline>
                        <Row className={classes.interiors}>
                          {projectData?.exteriorAmenities?.map((item, index) => (
                            <div key={`${item?._id}-${index}`} className={classes.innersDiv}>
                              <ListItemWithCheckMark mainClass="flex-align-center">
                                <div className={`${classes.floor_unit_item}`}>
                                  <span>{item?.title?.[selectedLanguage]}</span>
                                </div>
                              </ListItemWithCheckMark>
                            </div>
                          ))}
                        </Row>
                      </div>
                    </div>
                  </Col>

                  {/* <AverageRatesWithMarketTrends /> */}
                </div>

                {!!projectData?.projectUnit?.length && (
                  <div className={classes.MidSections}>
                    <div className={classes.unit_floor_main}>
                      <div
                        style={{
                          marginBottom: '20px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center'
                        }}>
                        <HeadingWithUnderline className="mb-4 mt-4" underlineColor="transparent">
                          <h5>{t('unitInfo.units')}</h5>
                        </HeadingWithUnderline>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <div style={{ display: 'flex', gap: '10px' }}>
                            <button
                              style={{
                                background: 'none',
                                borderRadius: '9px',
                                border: '1px solid #F2F2F2',
                                padding: '10px'
                              }}
                              onClick={handlePrev}>
                              <MdOutlineKeyboardArrowLeft size={25} />
                            </button>
                            <button
                              style={{
                                background: 'none',
                                borderRadius: '9px',
                                border: '1px solid #F2F2F2',
                                padding: '10px'
                              }}
                              onClick={handleNext}>
                              <MdOutlineKeyboardArrowRight size={25} />
                            </button>
                          </div>
                          <CustomOverlay
                            popoverClass={classes.popoverMain}
                            show={show}
                            target={target}
                            handleClose={(event) => {
                              setShow(!show);

                              if (event) {
                                setTarget(event.target);
                              } else {
                                setTarget(null);
                              }
                            }}
                            targetElement={
                              <Button
                                variant="whiteOutlined"
                                className={classes.view_btn}
                                label={t('availableUnits')}
                                rightIcon={<IoChevronDownOutline />}
                              />
                            }>
                            <div className={[classes.overlayBox, classes.p0].join(' ')}>
                              
                              <ul className={classes.listOptionsWithBrBtm}>
                                
                                {projectData?.projectUnit?.map((item, key) => (
                                  <li
                                    key={`${item?._id}-${key}`}
                                    data-selected={item?._id == selectedUnit?._id}
                                  >
                                      <button className='btnWrapper' onClick={() => setSelectedUnit(item)}>

                                     
                                    {`${selectedUnit?.unitType?.title?.[selectedLanguage]}, 
                                  ${item?.noOfRooms?.[selectedLanguage]}
                                  ${t('rooms')}, ${m2ToFt2({ area: item?.area, areaUnit })}`}
                                 </button> 
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </CustomOverlay>
                        </div>
                      </div>
                      <div>
                        <div className={classes.border_unit}>
                          <Row className={classes.unit_floor_row}>
                            <Col md={6}>
                              <ElasticCarousel
                                customClass={classes.unitfloorImages}
                                images={selectedUnit?.images ?? []}
                                breakPoints={[{ width: 1, itemsToShow: 1 }]}
                                customArrows
                              />
                            </Col>

                            <Col md={6}>
                              <div className={classes.unit_floor_list_div}>
                                <HeadingWithUnderline underlineColor="transparent">
                              

                                  {selectedUnit && (
                                    <h6>
                                      {`${selectedUnit?.unitType?.title?.[selectedLanguage]},
                                      ${selectedUnit?.noOfRooms?.[selectedLanguage]} ${t('rooms')},
                                      ${m2ToFt2({ area: selectedUnit?.area, areaUnit })}`}
                                    </h6>
                                  )}
                                </HeadingWithUnderline>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes?.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <IoPricetagOutline color="var(--primary-clr)" />{' '}
                                      {t('unitInfo.price')}
                                    </span>
                                    <span> ${selectedUnit?.price}</span>
                                  </div>
                                </ListItemWithCheckMark>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <BiArea color="var(--primary-clr)" /> {t('unitInfo.area')}
                                    </span>
                                    <span>{m2ToFt2({ area: selectedUnit?.area, areaUnit })}</span>
                                  </div>
                                </ListItemWithCheckMark>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <MdOutlineBedroomChild color="var(--primary-clr)" />{' '}
                                      {t('unitInfo.rooms')}
                                    </span>
                                    <span> {selectedUnit?.noOfRooms?.[selectedLanguage]}</span>
                                  </div>
                                </ListItemWithCheckMark>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <BiBath color="var(--primary-clr)" />{' '}
                                      {t('unitInfo.bathrooms')}
                                    </span>
                                    <span> {selectedUnit?.noOfBathrooms}</span>
                                  </div>
                                </ListItemWithCheckMark>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <TbParking color="var(--primary-clr)" />{' '}
                                      {t('unitInfo.carParking')}
                                    </span>
                                    <span>
                                      {selectedUnit?.carParking === 0
                                        ? 'N/A'
                                        : selectedUnit?.carParking}
                                    </span>
                                  </div>
                                </ListItemWithCheckMark>
                                <ListItemWithCheckMark showCheck={false} mainClass={classes.list}>
                                  <div className={`flex-sb ${classes.floor_unit_item}`}>
                                    <span>
                                      <RiCommunityLine color="var(--primary-clr)" />{' '}
                                      {t('unitInfo.typeOfUnit')}
                                    </span>
                                    <span>
                                      {' '}
                                      {selectedUnit?.unitType?.title?.[selectedLanguage]}
                                    </span>
                                  </div>
                                </ListItemWithCheckMark>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>{' '}
                  </div>
                )}

                <div className={classes.LastSections}>
                  <MortgageCalculator tKey="projectDetail" heading="" />
                </div>
              </Col>

              {/* Right column */}
              <Col md={12} lg={4} className={classes.col2}>
                <div className={classes.clientCard}>
                  <ClientManagerCard
                    pageData={projectData}
                    dataType={'project'}
                    data={projectData}
                  />
                </div>
                {thisPageBanners?.find((b) => b?.bannerType === 'vertical') && (
                  <div className={classes?.bannerAdContainer}>
                    <BannerImageAd
                      image={imageUrl(
                        thisPageBanners?.find((b) => b?.bannerType === 'vertical')?.image
                      )}
                      link={thisPageBanners?.find((b) => b?.bannerType === 'vertical')?.link}
                      className={classes.verticalBanner}
                    />
                  </div>
                )}
                {/* <div className={classes?.bannerAdContainer}>
                <BannerImageAd image={verticalBanner} className={classes.verticalBanner} />
              </div> */}
              </Col>
            </Row>
          </Container>
          <BankLoanBanner t={t} />
          <Container className="">
            {thisPageBanners?.find((b) => b?.bannerType === 'horizontal') && (
              <div className={classes?.bannerAdContainer}>
                <BannerImageAd
                  image={imageUrl(
                    thisPageBanners?.find((b) => b?.bannerType === 'horizontal')?.image
                  )}
                  link={thisPageBanners?.find((b) => b?.bannerType === 'horizontal')?.link}
                  className={classes.horizontalBanner}
                />
              </div>
            )}
           
          </Container>
          {isShareModalOpen && <ShareModal show={isShareModalOpen} setShow={setIsShareModalOpen} />}
        </div>
      )}
      <Footer showDownload={false} />
    </>
  );
};

export default ProjectDetail;


